import type { SliderProps } from './Slider.types'
import * as SliderPrimitive from '@radix-ui/react-slider'
import cn from 'classnames'
import { Icon } from '../icon'
import styles from './Slider.module.css'

export function Slider({
  ariaLabel,
  value,
  defaultValue,
  disabled = false,
  max = 100,
  min = 0,
  minStepsBetweenThumbs = 0,
  onValueChange,
  onValueCommit,
  step = 1,
  className,
}: SliderProps) {
  const thumbValues = defaultValue || value

  return (
    <div className={cn(styles.wrapper, disabled && styles.wrapperDisabled, className)}>
      <div className={styles.iconContainer}>
        <Icon glyph="MinusExtraSmall" size={16} />
      </div>
      <SliderPrimitive.Root
        className={styles.root}
        value={value}
        defaultValue={defaultValue}
        disabled={disabled}
        max={max}
        min={min}
        minStepsBetweenThumbs={minStepsBetweenThumbs}
        onValueChange={onValueChange}
        onValueCommit={onValueCommit}
        step={step}
      >
        <SliderPrimitive.Track className={styles.track}>
          <SliderPrimitive.Range className={styles.range} />
        </SliderPrimitive.Track>
        {thumbValues?.map((_, i) => (
          <SliderPrimitive.Thumb key={`${i}${ariaLabel}`} className={styles.thumb} aria-label={ariaLabel}>
            <Icon glyph="ChevronDoubleSmall" size={20} className={styles.thumbIcon} />
          </SliderPrimitive.Thumb>
        ))}
      </SliderPrimitive.Root>
      <div className={styles.iconContainer}>
        <Icon glyph="PlusExtraSmall" size={16} />
      </div>
    </div>
  )
}

Slider.displayName = 'Slider'
